import { ReactNode } from "react";
import { SubscriptionProvider } from "@/lib/subscription-provider";
import { BrandProvider } from "@/lib/brand-provider";
import { IntegrationsProvider } from "@/lib/integrations-provider";

// Main providers wrapper
export function ProvidersWrapper({ children }: { children: ReactNode }) {
  return (
    <BrandProvider>
      <SubscriptionProvider>
        <IntegrationsProvider>{children}</IntegrationsProvider>
      </SubscriptionProvider>
    </BrandProvider>
  );
}
